const ActionTypes = {
  LOGOUT_START: 'LogoutStart',
  LOGOUT_SUCCESS: 'LogoutSuccess',
  LOGOUT_FAILURE: 'LogoutFailure',
  INIT_STORE: 'INIT_STORE',
  LOGOUT_CLEANUP: 'LOGOUT_CLEANUP',
};

export default ActionTypes;
